import { render, staticRenderFns } from "./sentbox.vue?vue&type=template&id=1af9c85a&scoped=true&"
import script from "./sentbox.vue?vue&type=script&lang=js&"
export * from "./sentbox.vue?vue&type=script&lang=js&"
import style0 from "./sentbox.vue?vue&type=style&index=0&id=1af9c85a&lang=scss&scoped=true&"
import style1 from "./sentbox.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./sentbox.vue?vue&type=style&index=2&id=1af9c85a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af9c85a",
  null
  
)

export default component.exports